import {
	Button,
	Heading,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalOverlay,
	Text,
} from '@chakra-ui/react';
import useTimeZoneModal from './timezone.modal.controller';

interface TimezoneModalProps {
	isOpen: boolean;
	close: () => void;
}

export default function TimezoneModal(props: TimezoneModalProps) {
	const { t, handleChangeTimeZoneClick, currentTimeZone } = useTimeZoneModal(props);

	return (
		<>
			<Modal isOpen={props.isOpen} onClose={props.close} size="2xl" isCentered>
				<ModalOverlay />
				<ModalContent>
					<ModalHeader>
						<Heading mb="1" size="lg">
							{t('New timezone detected.')}
						</Heading>
					</ModalHeader>
					<ModalCloseButton />
					<ModalBody>
						<Heading size="md">{t('What is happening?')}</Heading>
						<Text>
							{t(
								'We have detected that your timezone has changed and it does not match the one you have set in your profile.'
							)}{' '}
							{t('This can be due to a change in your location or a change in your computer settings.')}
						</Text>
						<Heading mt="2" mb="1" size="md">
							{t('What should I do?')}
						</Heading>
						<Text>
							{t('If the timezone change is correct, you just need to update your profile timezone.')}{' '}
							{t('If you think this is a mistake, please contact us at info@timetime.in')}
						</Text>
					</ModalBody>

					<ModalFooter>
						<Button variant="ghost" mr={3} onClick={props.close}>
							{t('Close')}
						</Button>
						<Button colorScheme="primary" onClick={handleChangeTimeZoneClick}>
							{t('Change to {{timezone}}', { timezone: currentTimeZone })}
						</Button>
					</ModalFooter>
				</ModalContent>
			</Modal>
		</>
	);
}
